var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chat__image-wrapper"},[_c('div',{staticClass:"chat__avatar",class:{ 'chat-preview__avatar-online': _vm.isContactIdOnline },style:({ backgroundImage: 'url(' + _vm.pic + ')' })})])
}
var staticRenderFns = []

export { render, staticRenderFns }